// import {
//   Backdrop,
//   Box,
//   createTheme,
//   CssBaseline,
//   FormControl,
//   FormControlLabel,
//   IconButton,
//   InputAdornment,
//   Radio,
//   RadioGroup,
//   Skeleton,
//   TextField,
//   ThemeProvider,
// } from "@mui/material";
// import React from "react";
// import { useEffect } from "react";
// import { useState } from "react";
// import { connect } from "react-redux";
// import { Link, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { common_axios } from "../../../../App";
// import image from "../../../../assets/images/altruist.webp";
// import Loader from "../../../../components/Loader";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import DeleteIcon from "@mui/icons-material/Delete";
// import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
// import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
// import EditIcon from "@mui/icons-material/Edit";
// import BlockIcon from "@mui/icons-material/Block";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CancelIcon from "@mui/icons-material/Cancel";
// import { loginAsUser } from "../../../../redux/actions/auth";
// import { Fragment, useMemo, useRef } from "react";
// import Swal from "sweetalert2";

// import {
//   useAsyncDebounce,
//   useBlockLayout,
//   useColumnOrder,
//   useFilters,
//   useGlobalFilter,
//   usePagination,
//   useRowSelect,
//   useSortBy,
//   useTable,
// } from "react-table";
// import RoleName from "./RoleName";
// import moment from "moment";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// import axios from "axios";
// import { dateFormatter } from "../../../../helper/helper";
// import ViewRouteAlloted from "../../RouteManagment/User_Reseller/ViewRouteAlloted";
// import ViewSenderId from "../../SenderId/Admin Sender ID/ViewSenderId";
// import ViewTemplatesAdmin from "../../Template/Admin/ViewTemplatesAdmin";
// import LoginLoader from "../../../../components/LoginLoader";
// import ViewPendingSenderId from "../../SenderId/Reseller Sender ID/ViewPendingSenderId";
// import ViewUserSenderId from "./ViewUserSenderId";
// import ViewUserTemplate from "./ViewUserTemplate";
// import RechargeReports from "../../Reports/Recharge Reports/RechargeReports";
// import Rechargemanagement from "./Rechargemanagement";
// function UserProfile(props) {
//   const [count, setcount] = useState(0);
//   const [button, setButton] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [taglineType, setTaglineType] = useState();
//   // const [details, setDetails] = useState({
//   //   customerName: "",
//   //   phoneNumber: "",
//   //   address: "",
//   //   email: "",
//   // });
//   const [data, setData] = useState([
//     {
//       S_NO: "",
//       // uid: "",
//       username: "",
//       // userRoleId: "",
//       email: "",
//       action: "",
//       roleName: "",
//       status: "",
//     },
//   ]);

//   const [editState, setEditState] = useState({
//     userName: "",
//     email: "",
//     promoCutting: "",
//     account: "User",
//     lastLogin: "",
//     transCutting: "",
//     accountExpiry: "",
//     lastLoginIp: "",
//     transCutting: "",
//     number: "",
//     promoCutting: "",
//   });
//   // console.log("id", editState?.userName);
//   const [showPassword, setShowPassword] = useState(false);
//   const handleMouseDownPassword = () => setShowPassword(!showPassword);
//   const handleClickShowPassword = () => setShowPassword(!showPassword);
//   const [showPassword1, setShowPassword1] = useState(false);
//   const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
//   const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
//   const [showPassword2, setShowPassword2] = useState(false);
//   const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);
//   const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);

//   const { id } = useParams();
// // console.log("iii",id)
//   const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));

//   const callbackFunction = (childData) => {
//     setTaglineType(childData);
//   };

//   const customId1 = "custom-id-yess";
//   // const fetchUser = async () => {
//   //   setOpen(true);
//   //   try {
//   //     const res = await common_axios(
//   //       `admin/v1/${
//   //         roleType.name == "ROLE_RESELLER" ? "reseller" : "admin"
//   //       }/fetch/user-status/?userStatus=approved`
//   //     );

//   //     if (res.data.statusDescription.statusCode == 200) {
//   //       setOpen(false);
//   //       setcount(res.data.count);

//   //       setData(res.data.userStatus);
//   //     }
//   //   } catch (error) {
//   //     setOpen(false);
//   //     console.log(error);
//   //     await toast.error("Something went Wrong !! Please Check Your Network", {
//   //       theme: "colored",
//   //       toastId: customId1,
//   //     });
//   //   }
//   // };
//   // useEffect(async () => {
//   //   fetchUser();
//   // }, []);

//   // console.log({ data });

//   const columns = useMemo(
//     () => [
//       // {
//       //   Header: "S.No",
//       //   Footer: "S.No",
//       //   accessor: "serialnumber",
//       //   Cell: (row, index) => {
//       //     console.log(row, "helloo");
//       //     return <>{row.row.index}</>;
//       //   },
//       // },
//       {
//         Header: "Route Id",
//         Footer: "Route Id",
//         accessor: "routeId", // accessor is the "key" in the data
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             <>
//               <div>
//                 {cell.row.original.routeId ? (
//                   <div>{cell.row.original.routeId}</div>
//                 ) : (
//                   <div>NA</div>
//                 )}
//               </div>
//             </>
//           );
//         },
//       },

//       {
//         Header: "Route Name",
//         Footer: "Route Name",
//         accessor: "routeName",
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             <>
//               <div>
//                 {cell.row.original.routeName ? (
//                   <div>{cell.row.original.routeName}</div>
//                 ) : (
//                   <div>N/A</div>
//                 )}
//               </div>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Active",
//         Footer: "Active",
//         accessor: "active",
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             // <div>
//             //   {cell.row.original.roleName == "user" ? (
//             //     <div>User</div>
//             //   ) : (
//             //     <div>Reseller</div>
//             //   )}
//             // </div>
//             <>
//               <>
//                 <div>
//                   {cell.row.original.active ? (
//                     <div>{cell.row.original.active}</div>
//                   ) : (
//                     <div>N/A</div>
//                   )}
//                 </div>
//               </>
//             </>
//           );
//         },
//       },
//       {
//         Header: " Default",
//         Footer: " Default",
//         accessor: "status",
//         Cell: (cell) => {
//           // console.log(
//           //   cell,
//           //   cell.row.original,
//           //   cell.row.original.status,
//           //   cell.cell.row.original.enabled
//           // );
//           // const function2 = () => {
//           //   if (cell.row.original.enabled == "false") {
//           //     <div className="badge rounded-pill bg-danger">Blocked</div>;
//           //   }
//           // };
//           // console.log("going", cell.row.original.enabled == false);
//           return (
//             <>
//               <>
//                 <div>
//                   {cell.row.original.status ? (
//                     <div>{cell.row.original.status}</div>
//                   ) : (
//                     <div>N/A</div>
//                   )}
//                 </div>
//               </>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Open Template",
//         Footer: "Open Template ",
//         accessor: "openTemplate",
//         Cell: (cell) => {
//           // console.log(cell.row.original, cell.row.original.status);
//           return (
//             <>
//               <div>
//                 {cell.row.original.openTemplate ? (
//                   <div>{cell.row.original.openTemplate}</div>
//                 ) : (
//                   <div>N/A</div>
//                 )}
//               </div>
//             </>
//           );
//         },
//       },
//       {
//         Header: "Action",
//         Footer: "Action",
//         accessor: "action",
//         Cell: (cell) => {
//           return (
//             <>
//               {cell.row.original.approved == 1 ? (
//                 <>
//                   <button className="btn btn-secondary">
//                     {" "}
//                     <DeleteIcon />
//                     Remove
//                   </button>
//                 </>
//               ) : (
//                 <></>
//               )}
//             </>
//           );
//         },

//         disableFilters: true,
//       },
//     ],
//     []
//   );

//   const defaultColumn = useMemo(() => {
//     return {
//       Filter: ColumnFilter,
//     };
//   }, []);
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     // footerGroups,
//     rows,
//     page,
//     nextPage,
//     canNextPage,
//     previousPage,
//     canPreviousPage,
//     pageOptions,
//     gotoPage,
//     pageCount,
//     setPageSize,
//     prepareRow,
//     state,
//     setGlobalFilter,
//     selectedFlatRows,
//     setColumnOrder,
//     allColumns,
//     getToggleHideAllColumnsProps,
//   } = useTable(
//     {
//       columns,
//       data,
//       defaultColumn,
//       // initialState: { pageIndex: 1 }
//     },
//     useFilters,
//     useGlobalFilter,
//     useSortBy,
//     usePagination,
//     useRowSelect
//     // useColumnOrder,
//     // useBlockLayout,
//     // useSticky,
//     // (hooks) => {
//     //   hooks.visibleColumns.push((columns) => {
//     //     return [
//     //       {
//     //         id: "selection",
//     //         Header: ({ getToggleAllRowsSelectedProps }) => (
//     //           <CheckBox {...getToggleAllRowsSelectedProps()} />
//     //         ),
//     //         Cell: ({ row }) => (
//     //           <CheckBox {...row.getToggleRowSelectedProps()} />
//     //         ),
//     //       },
//     //       ...columns,
//     //     ];
//     //   });
//     // }
//   );
//   const { globalFilter, pageIndex, pageSize } = state;

//   const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

//   const onChange = useAsyncDebounce((value) => {
//     setGlobalFilter(value || undefined);
//   }, 1000);

//   const modalBlockUser = useRef(null);
//   const modalBlockUserClose = useRef(null);

//   const modelBlockUser = async () => {
//     await modalBlockUser.current.click();
//   };

//   const getUserDetails = async () => {
//     try {
//       setOpen(true);
//       const res = await common_axios(
//         `/admin/v1/user/profile/details?cpId=${id}`
//       );
//       // console.log(res.data);
//       if (res.data.statusDescription.statusCode == 200) {
//         setOpen(false);
//         // setDetails(res.data.userDetail);
//         await setEditState({
//           userName: res.data.userDetail.username,
//           name: res.data.userDetail.name,
//           uid: res.data.userDetail.uid,
//           email: res.data.userDetail.email,
//           promoCutting: "",
//           account: res.data.userDetail.roleName,
//           // lastLogin: res.data.userDetail.lastLoginTime
//           //   ? dateFormatter(res.data.userDetail.lastLoginTime)
//           //   : "Did not Logged in Yet!!",
//           lastLogin: res.data.userDetail.lastLoginTime
//             ? res.data.userDetail.lastLoginTime
//             : "Did not Logged in Yet!!",
//           transCutting: "",
//           accountExpiry: "",
//           lastLoginIp: "",
//           transCutting: "",
//           number: res.data.userDetail.mobile,
//           promoCutting: "",
//         });
//       } else {
//         setOpen(false);
//         Swal.fire({
//           icon: "error",
//             title: "Oops...",
//           text: res.data.statusDescription.description,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });

//         // await toast.error(res.data.statusDescription.description, {
//         //   theme: "colored",
//         // });
//       }
//     } catch (error) {
//       // console.log(error);
//       setOpen(false);
//       // await toast.error("Something went Wrong !! Please Check Your Network", {
//       //   theme: "colored",
//       // });
//       Swal.fire({
//         icon: "error",
//           title: "Oops...",
//         text:"Something went Wrong !! Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };

//   const EditUser = async () => {
//     const res = await axios.post(``);
//   };

//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: {
//             color: "red",
//           },
//         },
//       },
//     },
//   });
//   const validationSchema = yup.object({
//     newPassword: yup
//       .string()
//       .required("Please Enter your  password")
//       .min(8)
//       .max(40)
//       .matches(
//         /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
//         "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
//       ),
//     confirmPassword: yup
//       .string()
//       .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
      
//   });

//   useEffect(() => {
//     getUserDetails();
//   }, []);

//   const formik = useFormik({
//     initialValues: editState,

//     onReset: (initialValues) => ({
//       values: { initialValues },
//     }),
//     validateOnChange: true,
//     enableReinitialize: true,

//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       try {
//         setOpen(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API}/auth/v1/update/new/password`,
//           {
//             newPassword: values.newPassword,
//             userId: id,
//             confirmPassword: values.confirmPassword,
//           }
//         );

//         if (res.data.statusDescription.statusCode == 200) {
//           setOpen(false);
//           formik.handleReset();

//           // toast.success("Your Password has been changed successfully", {
//           //   theme: "colored",
//           // });
//           Swal.fire({
//             icon: "success",
//               // title: "Oops...",
//             text:"Your Password has been changed successfully",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });

//         } else {
//           setOpen(false);
//           // toast.error(res.data.statusDescription.description, {
//           //   theme: "colored",
//           // });

//           Swal.fire({
//             icon: "error",
//              title: "Oops...",
//             text:res.data.statusDescription.description,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//           // console.log(res.data.statusMessage);
//         }
//       } catch (error) {
//         // toast.error("Please Check Your Network");
//         // setOpen(false);
//         Swal.fire({
//           icon: "error",
//            title: "Oops...",
//           text:"Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     },
//   });

//   const formik1 = useFormik({
//     initialValues: editState,

//     onReset: () => ({
//       values: "",
//     }),
//     validateOnChange: true,
//     enableReinitialize: true,

//     // validationSchema: validationSchema1,
//     onSubmit: async (values) => {
//       try {
//         setOpen(true);
//         const res = await common_axios.post(`admin/v1/register/update/`, {
//           username: values.userName,
//           userId: id,
//           name: values.name,
//           email: values.email,
//           phoneNumber: "222"+values.phoneNumber,
//         });

//         if (res.data.statusDescription.statusCode == 200) {
//           setOpen(false);
//           await setTimeout(async () => {
//             // await toast.success("Updated Successfully", {
//             //   theme: "colored",
//             // });
//             Swal.fire({
//               icon: "success",
//               //  title: "Oops...",
//               text:"Updated Successfully",
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });

//           }, 100);
//         } else {
//           setOpen(false);
//           await setTimeout(async () => {
//             // await toast.error(res.data.statusDescription.description, {
//             //   theme: "colored",
//             // });
//             Swal.fire({
//               icon: "error",
//                title: "Oops...",
//               text:res.data.statusDescription.description,
//               // footer: '<a href="">Why do I have this issue?</a>'
//             });
//           }, 100);
//         }
//       } catch (error) {
//         setOpen(false);
//         await setTimeout(async () => {
//           // await toast.error("Something went wrong", {
//           //   theme: "colored",
//           // });
//             Swal.fire({
//             icon: "error",
//              title: "Oops...",
//             text:"Something went wrong",
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }, 100);
//       }
//     },
//   });

//   const blockUserAPI = async () => {
//     try {
//       setOpen(true);
//       const res = await common_axios(`/admin/v1/block/user/?cpId=${id}`);

//       if (res.data.statusDescription.statusCode == 200) {
//         // fetchUser();
//         setOpen(false);
//         // await setStatus("approved");
//         // await toast.success("User has been Blocked", {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "success",
//             // title: "Oops...",
//           text:"User has been Blocked",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       } else {
//         setOpen(false);
//         // await toast.error(res.data.statusDescription.description, {
//         //   theme: "colored",
//         //   toastId: customId1,
//         //   toastId: customId1,
//         // });

//         Swal.fire({
//           icon: "error",
//            title: "Oops...",
//           text:res.data.statusDescription.description,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } catch (error) {
//       setOpen(false);
//       // console.log(error);
//       // await toast.error("Something went wrong", {
//       //   theme: "colored",
//       //   toastId: customId1,
//       //   toastId: customId1,
//       // });
//       Swal.fire({
//         icon: "error",
//          title: "Oops...",
//         text:"Something went wrong",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   };
//   // .............Login As uUser...........................//
//   // async function LoginAsUser() {
//   //   try {
//   //     const res = await common_axios.post(
//   //       `${process.env.REACT_APP_COMMON_API}/admin/v1/login/super-admin/as/user`,
//   //       {
//   //         userName:editState?.userName
//   //     }
//   //     );
//   //     if (res.data.statusDescription.statusCode == 200) {
//   //       // setOpen(false);

//   //     }
//   //     // else if (res.data.statusDescription.statusCode == 202) {
//   //     //   toast.error(res.data.statusDescription.description, {
//   //     //     theme: "colored",
//   //     //   });
//   //     // }
//   //        else{
//   //       // setOpen(false);
//   //       // toast.error(res.data.statusDescription.description,{
//   //       //   // toastId: customId1,
//   //       //   theme: "colored",

//   //       // });

//   //     }
//   //   } catch (error) {
//   //     // setOpen(false);
//   //     toast.error("Please Check Your Network",{
//   //       // toastId: customId1,
//   //       theme: "colored",
//   //     });
//   //   }
//   // }


// // ...................................................................................................//
// // async function BulkTableget() {
// //  setData([])
// //  try {
// //   setOpen(true);

// //    const result = await common_axios.post(
// //      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/get/details`,

// //      // "http://192.168.167.66:5002/v1/get-all/file",
// //      // {
// //      // //   username: localStorage.getItem("usernamedisplayed"),
// //      // //   uploadType: "BlackList",
// //      //   pageNo: TableStatus?.pageNo,
// //      //   pageSize: TableStatus?.pageSize,
// //      // }

// //      {
// //        rechargeRequest:{
// //          pageNo: "1",
// //          pageSize:"10" ,
// //            // userId:uid.uid
// //           //  userId:userIds.includes("all") ? null : userIds,
// //         //  userId:id
// //         //  userId:id.map(function (item) {
// //         //     return parseInt(item);
// //         //    }),
// //         userId:[parseInt(id)],

// //        }
// //    }

// //    );
// //    if (result.data.statusDescription.statusCode == 200) {
// //      await setData(result.data.rechargeDeatils.content);
// //     //  await setData1(result.data.rechargeDeatils);
// //      setOpen(false);

// //      // await setTotalPage(result.data.fileUpload.totalPages);
// //      // await settotalPageCount(result.data.fileUpload.number);

// //      // document.getElementById("fileName").value = "";
// //    } else {
// //      // setTableLoader(false);
// //      setOpen(false);
// //      // toast.error(result.data.statusDescription.statusdescription,{
// //      //   toastId: customId1,
// //      //   theme: "colored",
// //      // });
// //      Swal.fire({
// //        icon: "error",
// //        title: "Oops...",
// //        text: result.data.statusDescription.statusMessage,
// //        // footer: '<a href="">Why do I have this issue?</a>'
// //      });
// //      // console.log(result.data.statusMessage);
// //    }
// //  } catch (error) {
// //    setOpen(false);
// //    Swal.fire({
// //      icon: "error",
// //      title: "Oops...",
// //      text: "Please Check Your Network",
// //      // footer: '<a href="">Why do I have this issue?</a>'
// //    });
// //  }
// // }
// // useEffect(()=>{
// //   if(id!=undefined){
// //     BulkTableget()

// //   }
// // },[id])
//   return (
//     <>
//       <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
//         <Backdrop
//           sx={{
//             transform: "translateZ(0)",
//             color: "#fff",
//             zIndex: (theme) => theme.zIndex.drawer + 1,
//           }}
//           open={open}
//         >
//           <Loader />
//         </Backdrop>

//         <div class="container-fluid">
//           <h6 class="font-weight-bolder mb-4">Profile Details Below </h6>
//           <div class="row">
//             <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
//               <div class="card mb-3 mt-4">
//                 <div class="card-header p-3 pt-2">
//                   <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//                     <i class="material-icons opacity-10 m-auto position-static">
//                       person
//                     </i>
//                   </div>
//                   <div class="text-end pt-1">
//                     <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
//                       Field(s) marked with{" "}
//                       <span className="text-danger fw-bold">*</span> are
//                       mandatory.
//                     </p>
//                   </div>
//                 </div>
//                 <div class="card-body">
//                   <div class="card shadow-none border mb-5 mt-4 bg_blue">
//                     <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                       User Details
//                     </span>
//                     <div class="card-body text-lg-start text-center">
//                       <div class="row">
//                         <div class="col-md-4">
//                           <label
//                             for="exampleInputEmail1"
//                             class="form-label m-0 labelfont"
//                           >
//                             User Name:-
//                           </label>
//                           <p class="sizefont_user m-0 d-inline-block ms-3 fw-bold">
//                             {editState?.userName}
//                           </p>
//                         </div>
//                         <div class="row mt-3">
//                           <div class="col-md-2">
//                             <label
//                               for="exampleInputEmail1"
//                               class="form-label m-0 labelfont"
//                             >
//                               Name
//                             </label>
//                             <p class="sizefont m-0 fw-bold">
//                               {editState?.name}
//                             </p>
//                           </div>
//                           <div class="col-md-2">
//                             <label
//                               for="exampleInputEmail1"
//                               class="form-label m-0 labelfont"
//                             >
//                               User Id
//                             </label>
//                             <p class="sizefont m-0 fw-bold">{editState?.uid}</p>
//                           </div>
//                           <div class="col-md-2">
//                             <label
//                               for="exampleInputEmail1"
//                               class="form-label m-0 labelfont"
//                             >
//                               Role
//                             </label>
//                             <p class="sizefont m-0 fw-bold">
//                               {editState?.account}
//                             </p>
//                           </div>
//                           <div class="col-md-2">
//                             <label
//                               for="exampleInputEmail1"
//                               class="form-label m-0 labelfont"
//                             >
//                               Phone Number
//                             </label>
//                             <p class="sizefont m-0 fw-bold">
//                               {editState?.number}
//                             </p>
//                           </div>

//                           <div className="col-md-4 text-start">
//                             <button
//                               type="button"
//                               // disabled={button == false}
//                               className="btn approved_Up w-auto m-0"
//                               style={{ fontSize: "12px" }}
//                               onClick={() => {
//                                 props.login(editState?.userName);
//                               }}
//                             >
//                               Login As User
//                               {/* <ArrowForwardIcon
//                                         style={{ fontSize: "17px" }}
//                                       /> */}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <ul class="nav nav-tabs pt-2" id="myTab" role="tablist">
//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link active"
//                         id="home-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#AccountDetails"
//                         type="button"
//                         role="tab"
//                         aria-controls="AccountDetails"
//                         aria-selected="true"
//                       >
//                         SMS
//                       </button>
//                     </li>

//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link ms-2"
//                         id="pills-contact-tab"
//                         data-bs-toggle="pill"
//                         data-bs-target="#pills-contact"
//                         type="button"
//                         role="tab"
//                         aria-controls="pills-contact"
//                         aria-selected="false"
//                       >
//                         Recharge
//                       </button>
//                     </li>

//                     <li class="nav-item" role="presentation">
//                       <button
//                         class="nav-link ms-2"
//                         id="pills-contact-tab"
//                         data-bs-toggle="pill"
//                         data-bs-target="#pills-password"
//                         type="button"
//                         role="tab"
//                         aria-controls="pills-contact"
//                         aria-selected="false"
//                       >
//                         Change Password
//                       </button>
//                     </li>
//                   </ul>
//                   <div class="tab-content" id="myTabContent">
//                     <div
//                       class="tab-pane fade show active"
//                       id="AccountDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                       <ul class="nav nav-tabs pt-4" id="myTab" role="tablist">
//                         <li class="nav-item" role="presentation">
//                           <button
//                             class="nav-link active"
//                             id="home-tab"
//                             data-bs-toggle="tab"
//                             data-bs-target="#sms"
//                             type="button"
//                             role="tab"
//                             aria-controls="AccountDetails"
//                             aria-selected="true"
//                           >
//                             Profile
//                           </button>
//                         </li>
//                         {JSON.parse(localStorage.getItem("Sidebaritems"))
//                           ?.name == "ROLE_SUPER_ADMIN" ? (
//                           <>
//                             {/* <li class="nav-item" role="presentation">
//                               <button
//                                 class="nav-link"
//                                 id="Route-tab"
//                                 data-bs-toggle="tab"
//                                 data-bs-target="#Route"
//                                 type="button"
//                                 role="tab"
//                                 aria-controls="profile"
//                                 aria-selected="false"
//                               >
//                                 Route Allocation
//                               </button>
//                             </li> */}
//                             <li class="nav-item" role="presentation">
//                               <button
//                                 class="nav-link ms-2"
//                                 id="SenderID-tab"
//                                 data-bs-toggle="tab"
//                                 data-bs-target="#SenderID"
//                                 type="button"
//                                 role="tab"
//                                 aria-controls="profile"
//                                 aria-selected="false"
//                               >
//                                 SenderID
//                               </button>
//                             </li>
//                             <li class="nav-item" role="presentation">
//                               <button
//                                 class="nav-link ms-2"
//                                 id="TemplateID-tab"
//                                 data-bs-toggle="tab"
//                                 data-bs-target="#TemplateID"
//                                 type="button"
//                                 role="tab"
//                                 aria-controls="profile"
//                                 aria-selected="false"
//                               >
//                                 Template
//                               </button>
//                             </li>
//                           </>
//                         ) : null}
//                       </ul>
//                       <div class="tab-content" id="myTabContent">
//                         <div
//                           class="tab-pane fade show active"
//                           id="sms"
//                           role="tabpanel"
//                           aria-labelledby="sms-tab"
//                         >
//                           <div className="text-end fw-bold">
//                             {/* Edit User
//                             <ArrowForwardIcon
//                               style={{
//                                 fontSize: "20px",
//                               }}
//                             />{" "} */}
//                             &nbsp; &nbsp;
//                             {button == false ? (
//                               <EditIcon
//                                 style={{
//                                   cursor: "pointer",
//                                   marginBottom: "20px",
//                                   fontSize: "20px",
//                                 }}
//                                 onClick={() => {
//                                   setButton(true);
//                                 }}
//                                 className="text-end mt-3 edit_btn_up"
//                               />
//                             ) : (
//                               <CancelIcon
//                                 style={{
//                                   cursor: "pointer",
//                                   fontSize: "20px",
//                                   marginBottom: "20px",
//                                 }}
//                                 onClick={() => {
//                                   setButton(false);
//                                 }}
//                                 className="text-end mt-3 cross_btn_up"
//                               />
//                             )}
//                           </div>

//                           <ThemeProvider theme={theme}>
//                             <div class="card shadow-none border mt-3 bg_blue">
//                               <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                                 Details
//                               </span>
//                               <div
//                                 class="card-body text-lg-start text-center"
//                                 id="card_body_profile"
//                               >
//                                 <form onSubmit={formik1.handleSubmit}>
//                                   <div class="row mb-3 ">
//                                     <div class="col-md-4">
//                                       <div className="d-flex align-items-center justify-content-between">
//                                         <TextField
//                                           disabled
//                                           required
//                                           className="w-100"
//                                           label="Username"
//                                           name="userName"
//                                           variant="outlined"
//                                           size="small"
//                                           type="text"
//                                           value={formik1.values.userName}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.userName &&
//                                             Boolean(formik1.errors.userName)
//                                           }
//                                           helperText={
//                                             formik1.touched.userName &&
//                                             formik1.errors.userName
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                     <div class="col-md-4">
//                                       <div className="d-flex align-items-center justify-content-between ">
//                                         <TextField
//                                           disabled={button == false}
//                                           required
//                                           className="w-100"
//                                           label="Email_id"
//                                           name="email"
//                                           variant="outlined"
//                                           size="small"
//                                           type="email"
//                                           value={formik1.values.email}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.email &&
//                                             Boolean(formik1.errors.email)
//                                           }
//                                           helperText={
//                                             formik1.touched.email &&
//                                             formik1.errors.email
//                                           }
//                                         />
//                                       </div>
//                                     </div>

//                                     <div className="col-md-4" id="inp_merge">
//                       <div className="d-flex h-100">
//                       <input className="inpt_width h-100"
//   disabled
//   value="+222"
// />
//                                         <TextField
//                                           disabled={button == false}
//                                           required
//                                           className="w-100"
//                                           label="Phone Number"
//                                           name="number"
//                                           variant="outlined"
//                                           size="small"
//                                           type="number"
//                                           value={formik1?.values?.number?.slice(3)}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.number &&
//                                             Boolean(formik1.errors.number)
//                                           }
//                                           helperText={
//                                             formik1.touched.number &&
//                                             formik1.errors.number
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                   </div>
//                                   <div class="row mb-3">
//                                     <div class="col-md-4 ">
//                                       <div className="d-flex align-items-center justify-content-between ">
//                                         <TextField
//                                           disabled
//                                           required
//                                           className="w-100"
//                                           label="Last Login Date"
//                                           name="lastLogin"
//                                           variant="outlined"
//                                           size="small"
//                                           type="text"
//                                           value={formik1.values.lastLogin}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.lastLogin &&
//                                             Boolean(formik1.errors.lastLogin)
//                                           }
//                                           helperText={
//                                             formik1.touched.lastLogin &&
//                                             formik1.errors.lastLogin
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                     <div class="col-md-4">
//                                       <div className="d-flex align-items-center justify-content-between ">
//                                         <TextField
//                                           disabled={button == false}
//                                           required
//                                           className="w-100"
//                                           label="Last Login Ip"
//                                           name="lastLoginIp"
//                                           variant="outlined"
//                                           size="small"
//                                           type="text"
//                                           value={formik1.values.lastLoginIp}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.lastLoginIp &&
//                                             Boolean(formik1.errors.lastLoginIp)
//                                           }
//                                           helperText={
//                                             formik1.touched.lastLoginIp &&
//                                             formik1.errors.lastLoginIp
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                     <div class="col-md-4">
//                                       <div className="d-flex align-items-center justify-content-between ">
//                                         <TextField
//                                           // disabled={button == false}
//                                           disabled
//                                           required
//                                           className="w-100"
//                                           label="Account Type"
//                                           name="account"
//                                           variant="outlined"
//                                           size="small"
//                                           type="text"
//                                           value={formik1.values.account}
//                                           onChange={formik1.handleChange}
//                                           error={
//                                             formik1.touched.account &&
//                                             Boolean(formik1.errors.account)
//                                           }
//                                           helperText={
//                                             formik1.touched.account &&
//                                             formik1.errors.account
//                                           }
//                                         />
//                                       </div>
//                                     </div>
//                                   </div>

//                                   <div className="text-end">
//                                     <button
//                                       type="submit"
//                                       disabled={button == false}
//                                       className="btn green_UP m-0"
//                                     >
//                                       Update
//                                       {/* <ArrowForwardIcon
//                                         style={{ fontSize: "17px" }}
//                                       /> */}
//                                     </button>

//                                     <button
//                                       style={{ marginLeft: "6px" }}
//                                       type="button"
//                                       disabled={button == false}
//                                       onClick={modelBlockUser}
//                                       className="btn failClr m-0 ms-2"
//                                     >
//                                       Block
//                                       {/* <BlockIcon style={{ fontSize: "17px" }} /> */}
//                                     </button>
//                                   </div>
//                                 </form>
//                               </div>
//                             </div>
//                           </ThemeProvider>
//                         </div>
//                       </div>

//                       <div
//                         class="tab-pane fade"
//                         id="profile"
//                         role="tabpanel"
//                         aria-labelledby="profile-tab"
//                       >
//                         <div class="card shadow-none border mt-5 bg_blue">
//                           <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                             Account Details
//                           </span>
//                           <div class="card-body text-lg-start text-center">
//                             <div class="row mb-3">
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Smpp User?
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     IP Validation
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Web Push Delivery
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Secure Reporting
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>
//                             <div class="row mt-3">
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Validate Spam
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Daily Email Notification
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     Open SenderId User
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div className="d-flex align-items-center justify-content-between">
//                                   <label
//                                     for="exampleInputEmail1"
//                                     class="form-label m-0 labelfont"
//                                   >
//                                     API Rights
//                                   </label>
//                                   <span class="badge bg-success">
//                                     Enabled <ThumbUpAltIcon />
//                                   </span>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
//                       "ROLE_SUPER_ADMIN" ? (
//                         <>
//                           <div
//                             class="tab-pane fade"
//                             id="Route"
//                             role="tabpanel"
//                             aria-labelledby="Route-tab"
//                           >
//                             {/* <div class="card-body"> */}
//                             <div class="card shadow-none border mb-5 mt-4 bg_blue">
//                               <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                                 Routes
//                               </span>
//                               <ViewRouteAlloted />
//                               {/* <div class="card-body text-lg-start text-center">
//                             <div className="d-flex justify-content-between my-3">
//                               <select
//                                 value={pageSize}
//                                 className="dropdown"
//                                 onChange={(e) => {
//                                   setPageSize(Number(e.target.value));
//                                 }}
//                               >
//                                 {[10, 25, 50].map((value, i) => {
//                                   return (
//                                     <option
//                                       className="dropdown-menu"
//                                       aria-labelledby="dropdownMenuButton1"
//                                       value={value}
//                                       key={value}
//                                     >
//                                       {" "}
//                                       Show {value}
//                                     </option>
//                                   );
//                                 })}
//                               </select>

//                               <div></div>
//                               <TextField
//                                 className="ms-4 "
//                                 style={{
//                                   borderRadius: "4px",
//                                 }}
//                                 type="text"
//                                 label="Search"
//                                 name="Search"
//                                 variant="outlined"
                             
//                                 size="small"
//                                 value={globalSearchValue || ""}
//                                 onChange={(e) => {
//                                   onChange(e.target.value);
//                                   setGlobalSearchValue(e.target.value);
//                                 }}
//                               />
//                             </div>

//                             <div className="text-end">
//                               {selectedFlatRows.length > 0 && (
//                                 <button
                        
//                                   className="btn bg-gradient-primary m-0"
//                                 >
//                                   Delete Users
//                                 </button>
//                               )}

                              
//                             </div>
//                             <div className="table-responsive">
//                               <table
//                                 {...getTableProps()}
//                                 id="example"
//                                 className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                              
//                               >
//                                 <thead>
//                                   {headerGroups.map((headerGroup) => (
//                                     <tr {...headerGroup.getHeaderGroupProps()}>
//                                       {headerGroup.headers.map((column) => (
//                                         <th
//                                           {...column.getHeaderProps(
//                                             column.getSortByToggleProps()
//                                           )}
//                                           className="text-left width_2"
//                                         >
//                                           {column.render("Header")}
//                                           <span>
//                                             {column.isSorted
//                                               ? column.isSortedDesc
//                                                 ? "↑"
//                                                 : "↓"
//                                               : ""}
//                                           </span>
//                                         </th>
//                                       ))}
//                                     </tr>
//                                   ))}
//                                 </thead>
//                                 <tbody {...getTableBodyProps()}>
//                                   {page.map((row) => {
//                                     prepareRow(row);
//                                     return (
//                                       <tr {...row.getRowProps()}>
//                                         {row.cells.map((cell) => {
//                                           return (
//                                             <td
//                                               {...cell.getCellProps()}
//                                               className="text-left"
//                                             >
//                                               {cell.render("Cell")}
//                                             </td>
//                                           );
//                                         })}
//                                       </tr>
//                                     );
//                                   })}
//                                 </tbody>
//                               </table>
//                             </div>
//                             <div className="d-flex justify-content-between align-items-center mt-3">
//                               <div>
//                                 <span>
//                                   Page:
//                                   <strong>
//                                     {pageIndex + 1} of {pageOptions.length}
//                                   </strong>
//                                 </span>

//                                 <span>
//                                   | Go to Page :{""}
//                                   <input
//                                     type="number"
                                  
//                                     value={pageIndex}
//                                     onChange={(e) => {
//                                       const pageNumber = e.target.value
//                                         ? Number(e.target.value) - 1
//                                         : 0;
//                                       gotoPage(pageNumber);
//                                     }}
//                                     style={{ width: "50px" }}
//                                   />
//                                 </span>
//                               </div>

//                               <div id="nikhil">
//                                 <button
//                                   className="btn btn_primary m-0"
//                                   type="button"
//                                   disabled={!canPreviousPage}
//                                   onClick={() => {
//                                     previousPage();
//                                   }}
//                                 >
//                                   Prev
//                                 </button>

//                                 <button
//                                   className="btn btn_primary m-0 ms-2"
//                                   type="button"
//                                   disabled={!canNextPage}
//                                   onClick={() => {
//                                     nextPage();
//                                   }}
//                                 >
//                                   Next
//                                 </button>
//                               </div>
//                             </div>
//                           </div> */}
//                             </div>
//                           </div>
//                           <div
//                             class="tab-pane fade"
//                             id="SenderID"
//                             role="tabpanel"
//                             aria-labelledby="Route-tab"
//                           >
//                             {" "}
//                             <div class="card shadow-none border mt-5 bg_blue">
//                               <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                                 Sender ID
//                               </span>
//                               <ViewUserSenderId id={editState?.uid}/>
//                               {/* <ViewSenderId /> */}
//                               {/* <ViewPendingSenderId/> */}
//                               {/* <div class="card-body text-lg-start text-center">
//                             <div className="d-flex justify-content-between my-3">
//                               <select
//                                 value={pageSize}
//                                 className="dropdown"
//                                 onChange={(e) => {
//                                   setPageSize(Number(e.target.value));
//                                 }}
//                               >
//                                 {[10, 25, 50].map((value, i) => {
//                                   return (
//                                     <option
//                                       className="dropdown-menu"
//                                       aria-labelledby="dropdownMenuButton1"
//                                       value={value}
//                                       key={value}
//                                     >
//                                       {" "}
//                                       Show {value}
//                                     </option>
//                                   );
//                                 })}
//                               </select>

//                               <div></div>
//                               <TextField
//                                 className="ms-4 "
//                                 style={{
//                                   borderRadius: "4px",
//                                 }}
//                                 type="text"
//                                 label="Search"
//                                 name="Search"
//                                 variant="outlined"
                          
//                                 size="small"
//                                 value={globalSearchValue || ""}
//                                 onChange={(e) => {
//                                   onChange(e.target.value);
//                                   setGlobalSearchValue(e.target.value);
//                                 }}
//                               />
//                             </div>

//                             <div className="text-end">
//                               {selectedFlatRows.length > 0 && (
//                                 <button className="btn bg-gradient-primary m-0">
//                                   Delete Users
//                                 </button>
//                               )}
//                             </div>
//                             <div className="table-responsive">
//                               <table
//                                 {...getTableProps()}
//                                 id="example"
//                                 className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
//                               >
//                                 <thead>
//                                   {headerGroups.map((headerGroup) => (
//                                     <tr {...headerGroup.getHeaderGroupProps()}>
//                                       {headerGroup.headers.map((column) => (
//                                         <th
//                                           {...column.getHeaderProps(
//                                             column.getSortByToggleProps()
//                                           )}
//                                           className="text-left width_2"
//                                         >
//                                           {column.render("Header")}
//                                           <span>
//                                             {column.isSorted
//                                               ? column.isSortedDesc
//                                                 ? "↑"
//                                                 : "↓"
//                                               : ""}
//                                           </span>
//                                         </th>
//                                       ))}
//                                     </tr>
//                                   ))}
//                                 </thead>
//                                 <tbody {...getTableBodyProps()}>
//                                   {page.map((row) => {
//                                     prepareRow(row);
//                                     return (
//                                       <tr {...row.getRowProps()}>
//                                         {row.cells.map((cell) => {
//                                           return (
//                                             <td
//                                               {...cell.getCellProps()}
//                                               className="text-left"
//                                             >
//                                               {cell.render("Cell")}
//                                             </td>
//                                           );
//                                         })}
//                                       </tr>
//                                     );
//                                   })}
//                                 </tbody>
//                               </table>
//                             </div>
//                             <div className="d-flex justify-content-between align-items-center mt-3">
//                               <div>
//                                 <span>
//                                   Page:
//                                   <strong>
//                                     {pageIndex + 1} of {pageOptions.length}
//                                   </strong>
//                                 </span>

//                                 <span>
//                                   | Go to Page :{""}
//                                   <input
//                                     type="number"
//                                     defaultValue={pageIndex + 1}
//                                     onChange={(e) => {
//                                       const pageNumber = e.target.value
//                                         ? Number(e.target.value) - 1
//                                         : 0;
//                                       gotoPage(pageNumber);
//                                     }}
//                                     style={{ width: "50px" }}
//                                   />
//                                 </span>
//                               </div>

//                               <div id="nikhil">
//                                 <button
//                                   className="btn btn_primary m-0"
//                                   type="button"
//                                   disabled={!canPreviousPage}
//                                   onClick={() => {
//                                     previousPage();
//                                   }}
//                                 >
//                                   Prev
//                                 </button>

//                                 <button
//                                   className="btn btn_primary m-0 ms-2"
//                                   type="button"
//                                   disabled={!canNextPage}
//                                   onClick={() => {
//                                     nextPage();
//                                   }}
//                                 >
//                                   Next
//                                 </button>
//                               </div>
//                             </div>
//                           </div> */}
//                             </div>
//                           </div>
//                           <div
//                             class="tab-pane fade"
//                             id="TemplateID"
//                             role="tabpanel"
//                             aria-labelledby="TemplateID-tab"
//                           >
//                             {" "}
//                             <div class="card shadow-none border mt-5 bg_blue">
//                               <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                                 Template-ID
//                               </span>

//                               {/* <div class="card-body text-lg-start text-center">
//                             <div className="d-flex justify-content-between my-3">
//                               <select
//                                 value={pageSize}
//                                 className="dropdown"
//                                 onChange={(e) => {
//                                   setPageSize(Number(e.target.value));
//                                 }}
//                               >
//                                 {[10, 25, 50].map((value, i) => {
//                                   return (
//                                     <option
//                                       className="dropdown-menu"
//                                       aria-labelledby="dropdownMenuButton1"
//                                       value={value}
//                                       key={value}
//                                     >
//                                       {" "}
//                                       Show {value}
//                                     </option>
//                                   );
//                                 })}
//                               </select>

//                               <div></div>
//                               <TextField
//                                 className="ms-4 "
//                                 style={{
//                                   borderRadius: "4px",
//                                 }}
//                                 type="text"
//                                 label="Search"
//                                 name="Search"
//                                 variant="outlined"
                        
//                                 size="small"
//                                 value={globalSearchValue || ""}
//                                 onChange={(e) => {
//                                   onChange(e.target.value);
//                                   setGlobalSearchValue(e.target.value);
//                                 }}
//                               />
//                             </div>

//                             <div className="text-end">
//                               {selectedFlatRows.length > 0 && (
//                                 <button className="btn bg-gradient-primary m-0">
//                                   Delete Users
//                                 </button>
//                               )}
//                             </div>
//                             <div className="table-responsive">
//                               <table
//                                 {...getTableProps()}
//                                 id="example"
//                                 className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
//                               >
//                                 <thead>
//                                   {headerGroups.map((headerGroup) => (
//                                     <tr {...headerGroup.getHeaderGroupProps()}>
//                                       {headerGroup.headers.map((column) => (
//                                         <th
//                                           {...column.getHeaderProps(
//                                             column.getSortByToggleProps()
//                                           )}
//                                           className="text-left width_2"
//                                         >
//                                           {column.render("Header")}
//                                           <span>
//                                             {column.isSorted
//                                               ? column.isSortedDesc
//                                                 ? "↑"
//                                                 : "↓"
//                                               : ""}
//                                           </span>
//                                         </th>
//                                       ))}
//                                     </tr>
//                                   ))}
//                                 </thead>
//                                 <tbody {...getTableBodyProps()}>
//                                   {page.map((row) => {
//                                     prepareRow(row);
//                                     return (
//                                       <tr {...row.getRowProps()}>
//                                         {row.cells.map((cell) => {
//                                           return (
//                                             <td
//                                               {...cell.getCellProps()}
//                                               className="text-left"
//                                             >
//                                               {cell.render("Cell")}
//                                             </td>
//                                           );
//                                         })}
//                                       </tr>
//                                     );
//                                   })}
//                                 </tbody>
//                               </table>
//                             </div>
//                             <div className="d-flex justify-content-between align-items-center mt-3">
//                               <div>
//                                 <span>
//                                   Page:
//                                   <strong>
//                                     {pageIndex + 1} of {pageOptions.length}
//                                   </strong>
//                                 </span>

//                                 <span>
//                                   | Go to Page :{""}
//                                   <input
//                                     type="number"
                                   
//                                     value={pageIndex}
//                                     onChange={(e) => {
//                                       const pageNumber = e.target.value
//                                         ? Number(e.target.value) - 1
//                                         : 0;
//                                       gotoPage(pageNumber);
//                                     }}
//                                     style={{ width: "50px" }}
//                                   />
//                                 </span>
//                               </div>

//                               <div id="nikhil">
//                                 <button
//                                   className="btn btn_primary m-0"
//                                   type="button"
//                                   disabled={!canPreviousPage}
//                                   onClick={() => {
//                                     previousPage();
//                                   }}
//                                 >
//                                   Prev
//                                 </button>

//                                 <button
//                                   className="btn btn_primary m-0 ms-2"
//                                   type="button"
//                                   disabled={!canNextPage}
//                                   onClick={() => {
//                                     nextPage();
//                                   }}
//                                 >
//                                   Next
//                                 </button>
//                               </div>
//                             </div>
//                           </div> */}
//                               {/* <ViewTemplatesAdmin /> */}
// <ViewUserTemplate id= {editState?.uid}/>
//                             </div>
//                           </div>
//                         </>
//                       ) : null}
//                       {/* <div
//                         class="tab-pane fade "
//                         id="SenderMasking"
//                         role="tabpanel"
//                         aria-labelledby="SenderMasking-tab"
//                       >
//                         <div class="card shadow-none border mt-5 bg_blue">
//                           <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                             Voice Details
//                           </span>
//                           <div class="card-body text-lg-start text-center">
//                             <div class="row">
//                               <div class="col-md-3">
//                                 <div class="input-group input-group-outline mb-3">
//                                   <label class="form-label">
//                                     Name
//                                     <span class="text-danger fw-bold">*</span>
//                                   </label>
//                                   <input type="text" class="form-control" />
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div class="input-group input-group-outline mb-3">
//                                   <label class="form-label">
//                                     Mobile no
//                                     <span class="text-danger fw-bold">*</span>
//                                   </label>
//                                   <input type="password" class="form-control" />
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div class="input-group input-group-outline mb-3">
//                                   <label class="form-label">
//                                     Email id
//                                     <span class="text-danger fw-bold">*</span>
//                                   </label>
//                                   <input type="text" class="form-control" />
//                                 </div>
//                               </div>
//                               <div class="col-md-3">
//                                 <div class="input-group input-group-outline mb-3">
//                                   <label class="form-label">
//                                     Role
//                                     <span class="text-danger fw-bold">*</span>
//                                   </label>
//                                   <input type="text" class="form-control" />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div> */}

//                       <div
//                         class="tab-pane fade "
//                         id="Recharge"
//                         role="tabpanel"
//                         aria-labelledby="Recharge-tab"
//                       >
//                       </div>
                      
//                     </div>

//                     <div
//                       class="tab-pane fade"
//                       id="pills-profile"
//                       role="tabpanel"
//                       aria-labelledby="pills-profile-tab"
//                     >
//                       ...888
//                     </div>
//                     <div
//                       class="tab-pane fade"
//                       id="pills-contact"
//                       role="tabpanel"
//                       aria-labelledby="pills-contact-tab"
//                     >
//                      <Rechargemanagement
//                      />
//                     </div>
//                     <div
//                       class="tab-pane fade"
//                       id="pills-child"
//                       role="tabpanel"
//                       aria-labelledby="pills-contact-tab"
//                     >
//                       child
//                     </div>
//                     <div
//                       class="tab-pane fade"
//                       id="pills-password"
//                       role="tabpanel"
//                       aria-labelledby="pills-contact-tab"
//                     >
//                       <div class="card shadow-none border mb-5 mt-5  bg_blue">
//                         <span class="badge rounded-pill bg-primary mt-n3 ms-5">
//                           Change Password
//                         </span>
//                         <div className="card-body text-lg-start text-center">
//                           <ThemeProvider theme={theme}>
//                             <form onSubmit={formik.handleSubmit}>
//                               <div className="row">
//                                 <div className="col-md-4">
//                                   <TextField
//                                     required
//                                     className="w-100"
//                                     label="New Password"
//                                     name="newPassword"
//                                     type={showPassword1 ? "text" : "password"}
//                                     variant="outlined"
//                                     size="small"
//                                     value={formik.values.newPassword}
//                                     onChange={formik.handleChange}
//                                     error={
//                                       formik.touched.newPassword &&
//                                       Boolean(formik.errors.newPassword)
//                                     }
//                                     helperText={
//                                       formik.touched.newPassword &&
//                                       formik.errors.newPassword
//                                     }
//                                     InputProps={{
//                                       // <-- This is where the toggle button is added.
//                                       endAdornment: (
//                                         <InputAdornment position="end">
//                                           <IconButton
//                                             aria-label="toggle password visibility"
//                                             onClick={handleClickShowPassword1}
//                                             onMouseDown={
//                                               handleMouseDownPassword1
//                                             }
//                                           >
//                                             {showPassword1 ? (
//                                               <VisibilityIcon
//                                                 sx={{ color: "#85CBF2" }}
//                                               />
//                                             ) : (
//                                               <VisibilityOffIcon
//                                                 sx={{ color: "#85CBF2" }}
//                                               />
//                                             )}
//                                           </IconButton>
//                                         </InputAdornment>
//                                       ),
//                                     }}
//                                   />
//                                 </div>

//                                 <div className="col-md-4">
//                                   <div className="input-group input-group-outline mb-3">
//                                     <TextField
//                                       required
//                                       className="w-100"
//                                       label="Confirm Password"
//                                       name="confirmPassword"
//                                       type={showPassword2 ? "text" : "password"}
//                                       variant="outlined"
//                                       size="small"
//                                       value={formik.values.confirmPassword}
//                                       onChange={formik.handleChange}
//                                       error={
//                                         formik.touched.confirmPassword &&
//                                         Boolean(formik.errors.confirmPassword)
//                                       }
//                                       helperText={
//                                         formik.touched.confirmPassword &&
//                                         formik.errors.confirmPassword
//                                       }
//                                       InputProps={{
//                                         // <-- This is where the toggle button is added.
//                                         endAdornment: (
//                                           <InputAdornment position="end">
//                                             <IconButton
//                                               aria-label="toggle password visibility"
//                                               onClick={handleClickShowPassword2}
//                                               onMouseDown={
//                                                 handleMouseDownPassword2
//                                               }
//                                             >
//                                               {showPassword2 ? (
//                                                 <VisibilityIcon
//                                                   sx={{ color: "#85CBF2" }}
//                                                 />
//                                               ) : (
//                                                 <VisibilityOffIcon
//                                                   sx={{ color: "#85CBF2" }}
//                                                 />
//                                               )}
//                                             </IconButton>
//                                           </InputAdornment>
//                                         ),
//                                       }}
//                                     />
//                                   </div>
//                                 </div>
//                               </div>
//                               <div className="d-flex justify-content-between">

//                               <button
//                                   style={{ marginLeft: "6px" }}
//                                   type="button"
//                                   onClick={formik.resetForm}
//                                   className="btn resetBtn_UP m-0 ms-2"
//                                 >
//                                   Reset
//                                   {/* <i className="material-icons opacity-10">
//                                     settings_backup_restore
//                                   </i> */}
//                                 </button>

//                                 <button
//                                   type="submit"
//                                   className="btn bg-gradient-primary m-0"
//                                 >
//                                   Submit
//                                   {/* <i className="material-icons opacity-10">
//                                     arrow_right_alt
//                                   </i> */}
//                                 </button>

                                
//                               </div>
//                             </form>
//                           </ThemeProvider>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <LoginLoader visible={props.loading} />
//       </main>
//     </>
//   );
// }

// const mapStateToProps = (state) => ({
//   loading: state.authReducer.loading,
// });

// const mapDispatchToProps = (dispatch) => ({
//   login: (username) => dispatch(loginAsUser(username)),
// });

// export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);















import {
  Backdrop,
  Box,
  createTheme,
  CssBaseline,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Skeleton,
  TextField,
  ThemeProvider,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { common_axios } from "../../../../App";
import image from "../../../../assets/images/altruist.webp";
import Loader from "../../../../components/Loader";
import { useFormik } from "formik";
import * as yup from "yup";
import DeleteIcon from "@mui/icons-material/Delete";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CancelIcon from "@mui/icons-material/Cancel";
import { loginAsUser } from "../../../../redux/actions/auth";
import { Fragment, useMemo, useRef } from "react";
import Swal from "sweetalert2";

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import RoleName from "./RoleName";
import moment from "moment";
import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import { dateFormatter } from "../../../../helper/helper";
import ViewRouteAlloted from "../../RouteManagment/User_Reseller/ViewRouteAlloted";
import ViewSenderId from "../../SenderId/Admin Sender ID/ViewSenderId";
import ViewTemplatesAdmin from "../../Template/Admin/ViewTemplatesAdmin";
import LoginLoader from "../../../../components/LoginLoader";
import ViewPendingSenderId from "../../SenderId/Reseller Sender ID/ViewPendingSenderId";
import ViewUserSenderId from "./ViewUserSenderId";
import ViewUserTemplate from "./ViewUserTemplate";
import RechargeReports from "../../Reports/Recharge Reports/RechargeReports";
import Rechargemanagement from "./Rechargemanagement";
function UserProfile(props) {
  const [count, setcount] = useState(0);
  const [button, setButton] = useState(false);
  const [open, setOpen] = useState(false);
  const [taglineType, setTaglineType] = useState();
  // const [details, setDetails] = useState({
  //   customerName: "",
  //   phoneNumber: "",
  //   address: "",
  //   email: "",
  // });
  const [data, setData] = useState([
    {
      S_NO: "",
      // uid: "",
      username: "",
      // userRoleId: "",
      email: "",
      action: "",
      roleName: "",
      status: "",
    },
  ]);

  const [editState, setEditState] = useState({
    userName: "",
    email: "",
    promoCutting: "",
    account: "User",
    lastLogin: "",
    transCutting: "",
    accountExpiry: "",
    lastLoginIp: "",
    transCutting: "",
    number: "",
    promoCutting: "",
  });
  // console.log("id", editState?.userName);
  const [showPassword, setShowPassword] = useState(false);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const [showPassword1, setShowPassword1] = useState(false);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);

  const { id } = useParams();
// console.log("iii",id)
  const roleType = JSON.parse(localStorage.getItem("Sidebaritems"));

  const callbackFunction = (childData) => {
    setTaglineType(childData);
  };

  const customId1 = "custom-id-yess";
  // const fetchUser = async () => {
  //   setOpen(true);
  //   try {
  //     const res = await common_axios(
  //       `admin/v1/${
  //         roleType.name == "ROLE_RESELLER" ? "reseller" : "admin"
  //       }/fetch/user-status/?userStatus=approved`
  //     );

  //     if (res.data.statusDescription.statusCode == 200) {
  //       setOpen(false);
  //       setcount(res.data.count);

  //       setData(res.data.userStatus);
  //     }
  //   } catch (error) {
  //     setOpen(false);
  //     console.log(error);
  //     await toast.error("Something went Wrong !! Please Check Your Network", {
  //       theme: "colored",
  //       toastId: customId1,
  //     });
  //   }
  // };
  // useEffect(async () => {
  //   fetchUser();
  // }, []);

  // console.log({ data });

  const columns = useMemo(
    () => [
      // {
      //   Header: "S.No",
      //   Footer: "S.No",
      //   accessor: "serialnumber",
      //   Cell: (row, index) => {
      //     console.log(row, "helloo");
      //     return <>{row.row.index}</>;
      //   },
      // },
      {
        Header: "Route Id",
        Footer: "Route Id",
        accessor: "routeId", // accessor is the "key" in the data
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            <>
              <div>
                {cell.row.original.routeId ? (
                  <div>{cell.row.original.routeId}</div>
                ) : (
                  <div>NA</div>
                )}
              </div>
            </>
          );
        },
      },

      {
        Header: "Route Name",
        Footer: "Route Name",
        accessor: "routeName",
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            <>
              <div>
                {cell.row.original.routeName ? (
                  <div>{cell.row.original.routeName}</div>
                ) : (
                  <div>N/A</div>
                )}
              </div>
            </>
          );
        },
      },
      {
        Header: "Active",
        Footer: "Active",
        accessor: "active",
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            // <div>
            //   {cell.row.original.roleName == "user" ? (
            //     <div>User</div>
            //   ) : (
            //     <div>Reseller</div>
            //   )}
            // </div>
            <>
              <>
                <div>
                  {cell.row.original.active ? (
                    <div>{cell.row.original.active}</div>
                  ) : (
                    <div>N/A</div>
                  )}
                </div>
              </>
            </>
          );
        },
      },
      {
        Header: " Default",
        Footer: " Default",
        accessor: "status",
        Cell: (cell) => {
          // console.log(
          //   cell,
          //   cell.row.original,
          //   cell.row.original.status,
          //   cell.cell.row.original.enabled
          // );
          // const function2 = () => {
          //   if (cell.row.original.enabled == "false") {
          //     <div className="badge rounded-pill bg-danger">Blocked</div>;
          //   }
          // };
          // console.log("going", cell.row.original.enabled == false);
          return (
            <>
              <>
                <div>
                  {cell.row.original.status ? (
                    <div>{cell.row.original.status}</div>
                  ) : (
                    <div>N/A</div>
                  )}
                </div>
              </>
            </>
          );
        },
      },
      {
        Header: "Open Template",
        Footer: "Open Template ",
        accessor: "openTemplate",
        Cell: (cell) => {
          // console.log(cell.row.original, cell.row.original.status);
          return (
            <>
              <div>
                {cell.row.original.openTemplate ? (
                  <div>{cell.row.original.openTemplate}</div>
                ) : (
                  <div>N/A</div>
                )}
              </div>
            </>
          );
        },
      },
      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.approved == 1 ? (
                <>
                  <button className="btn btn-secondary">
                    {" "}
                    <DeleteIcon />
                    Remove
                  </button>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },

        disableFilters: true,
      },
    ],
    []
  );

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );
  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const modalBlockUser = useRef(null);
  const modalBlockUserClose = useRef(null);

  const modelBlockUser = async () => {
    await modalBlockUser.current.click();
  };

  const getUserDetails = async () => {
    try {
      setOpen(true);
      const res = await common_axios(
        `/admin/v1/user/profile/details?cpId=${id}`
      );
      // console.log(res.data);
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        // setDetails(res.data.userDetail);
        await setEditState({
          userName: res.data.userDetail.username,
          name: res.data.userDetail.name,
          uid: res.data.userDetail.uid,
          email: res.data.userDetail.email,
          promoCutting: "",
          account: res.data.userDetail.roleName,
          // lastLogin: res.data.userDetail.lastLoginTime
          //   ? dateFormatter(res.data.userDetail.lastLoginTime)
          //   : "Did not Logged in Yet!!",
          lastLogin: res.data.userDetail.lastLoginTime
            ? res.data.userDetail.lastLoginTime
            : "Did not Logged in Yet!!",
          transCutting: "",
          accountExpiry: "",
          lastLoginIp: "",
          transCutting: "",
          number: res.data.userDetail.mobile,
          promoCutting: "",
        });
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
            title: "Oops...",
          text: res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });

        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);
      // await toast.error("Something went Wrong !! Please Check Your Network", {
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
          title: "Oops...",
        text:"Something went Wrong !! Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };

  const EditUser = async () => {
    const res = await axios.post(``);
  };

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const validationSchema = yup.object({
    newPassword: yup
      .string()
      .required("Please Enter your  password")
      .min(8)
      .max(40)
      .matches(
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        "Must Contain at least 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
      
  });

  useEffect(() => {
    getUserDetails();
  }, []);

  const formik = useFormik({
    initialValues: editState,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,
    enableReinitialize: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API}/auth/v2/update/new/password`,
          {
            newPassword: values.newPassword,
            userId: id,
            confirmPassword: values.confirmPassword,
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          formik.handleReset();

          // toast.success("Your Password has been changed successfully", {
          //   theme: "colored",
          // });
          Swal.fire({
            icon: "success",
              // title: "Oops...",
            text:"Your Password has been changed successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });

        } else {
          setOpen(false);
          // toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          // });

          Swal.fire({
            icon: "error",
             title: "Oops...",
            text:res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          // console.log(res.data.statusMessage);
        }
      } catch (error) {
        // toast.error("Please Check Your Network");
        // setOpen(false);
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:"Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  const formik1 = useFormik({
    initialValues: editState,

    onReset: () => ({
      values: "",
    }),
    validateOnChange: true,
    enableReinitialize: true,

    // validationSchema: validationSchema1,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await common_axios.post(`admin/v1/register/update/`, {
          username: values.userName,
          userId: id,
          name: values.name,
          email: values.email,
          phoneNumber: "222"+values.phoneNumber,
        });

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.success("Updated Successfully", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              //  title: "Oops...",
              text:"Updated Successfully",
              // footer: '<a href="">Why do I have this issue?</a>'
            });

          }, 100);
        } else {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
               title: "Oops...",
              text:res.data.statusDescription.description,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        await setTimeout(async () => {
          // await toast.error("Something went wrong", {
          //   theme: "colored",
          // });
            Swal.fire({
            icon: "error",
             title: "Oops...",
            text:"Something went wrong",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });

  const blockUserAPI = async () => {
    try {
      setOpen(true);
      const res = await common_axios(`/admin/v1/block/user/?cpId=${id}`);

      if (res.data.statusDescription.statusCode == 200) {
        // fetchUser();
        setOpen(false);
        // await setStatus("approved");
        // await toast.success("User has been Blocked", {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "success",
            // title: "Oops...",
          text:"User has been Blocked",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      } else {
        setOpen(false);
        // await toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        //   toastId: customId1,
        //   toastId: customId1,
        // });

        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // console.log(error);
      // await toast.error("Something went wrong", {
      //   theme: "colored",
      //   toastId: customId1,
      //   toastId: customId1,
      // });
      Swal.fire({
        icon: "error",
         title: "Oops...",
        text:"Something went wrong",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  };
  // .............Login As uUser...........................//
  // async function LoginAsUser() {
  //   try {
  //     const res = await common_axios.post(
  //       `${process.env.REACT_APP_COMMON_API}/admin/v1/login/super-admin/as/user`,
  //       {
  //         userName:editState?.userName
  //     }
  //     );
  //     if (res.data.statusDescription.statusCode == 200) {
  //       // setOpen(false);

  //     }
  //     // else if (res.data.statusDescription.statusCode == 202) {
  //     //   toast.error(res.data.statusDescription.description, {
  //     //     theme: "colored",
  //     //   });
  //     // }
  //        else{
  //       // setOpen(false);
  //       // toast.error(res.data.statusDescription.description,{
  //       //   // toastId: customId1,
  //       //   theme: "colored",

  //       // });

  //     }
  //   } catch (error) {
  //     // setOpen(false);
  //     toast.error("Please Check Your Network",{
  //       // toastId: customId1,
  //       theme: "colored",
  //     });
  //   }
  // }


// ...................................................................................................//
// async function BulkTableget() {
//  setData([])
//  try {
//   setOpen(true);

//    const result = await common_axios.post(
//      `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/get/details`,

//      // "http://192.168.167.66:5002/v1/get-all/file",
//      // {
//      // //   username: localStorage.getItem("usernamedisplayed"),
//      // //   uploadType: "BlackList",
//      //   pageNo: TableStatus?.pageNo,
//      //   pageSize: TableStatus?.pageSize,
//      // }

//      {
//        rechargeRequest:{
//          pageNo: "1",
//          pageSize:"10" ,
//            // userId:uid.uid
//           //  userId:userIds.includes("all") ? null : userIds,
//         //  userId:id
//         //  userId:id.map(function (item) {
//         //     return parseInt(item);
//         //    }),
//         userId:[parseInt(id)],

//        }
//    }

//    );
//    if (result.data.statusDescription.statusCode == 200) {
//      await setData(result.data.rechargeDeatils.content);
//     //  await setData1(result.data.rechargeDeatils);
//      setOpen(false);

//      // await setTotalPage(result.data.fileUpload.totalPages);
//      // await settotalPageCount(result.data.fileUpload.number);

//      // document.getElementById("fileName").value = "";
//    } else {
//      // setTableLoader(false);
//      setOpen(false);
//      // toast.error(result.data.statusDescription.statusdescription,{
//      //   toastId: customId1,
//      //   theme: "colored",
//      // });
//      Swal.fire({
//        icon: "error",
//        title: "Oops...",
//        text: result.data.statusDescription.statusMessage,
//        // footer: '<a href="">Why do I have this issue?</a>'
//      });
//      // console.log(result.data.statusMessage);
//    }
//  } catch (error) {
//    setOpen(false);
//    Swal.fire({
//      icon: "error",
//      title: "Oops...",
//      text: "Please Check Your Network",
//      // footer: '<a href="">Why do I have this issue?</a>'
//    });
//  }
// }
// useEffect(()=>{
//   if(id!=undefined){
//     BulkTableget()

//   }
// },[id])
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>

        <div class="container-fluid">
          <h6 class="font-weight-bolder mb-4">Profile Details Below </h6>
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i class="material-icons opacity-10 m-auto position-static">
                      person
                    </i>
                  </div>
                  <div class="text-end pt-1">
                    <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                </div>
                <div class="card-body">
                  <div class="card shadow-none border mb-5 mt-4 bg_blue">
                    <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                      User Details
                    </span>
                    <div class="card-body text-lg-start text-center">
                      <div class="row">
                        <div class="col-md-4">
                          <label
                            for="exampleInputEmail1"
                            class="form-label m-0 labelfont"
                          >
                            User Name:-
                          </label>
                          <p class="sizefont_user m-0 d-inline-block ms-3 fw-bold">
                            {editState?.userName}
                          </p>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-2">
                            <label
                              for="exampleInputEmail1"
                              class="form-label m-0 labelfont"
                            >
                              Name
                            </label>
                            <p class="sizefont m-0 fw-bold">
                              {editState?.name}
                            </p>
                          </div>
                          <div class="col-md-2">
                            <label
                              for="exampleInputEmail1"
                              class="form-label m-0 labelfont"
                            >
                              User Id
                            </label>
                            <p class="sizefont m-0 fw-bold">{editState?.uid}</p>
                          </div>
                          <div class="col-md-2">
                            <label
                              for="exampleInputEmail1"
                              class="form-label m-0 labelfont"
                            >
                              Role
                            </label>
                            <p class="sizefont m-0 fw-bold">
                              {editState?.account}
                            </p>
                          </div>
                          <div class="col-md-2">
                            <label
                              for="exampleInputEmail1"
                              class="form-label m-0 labelfont"
                            >
                              Phone Number
                            </label>
                            <p class="sizefont m-0 fw-bold">
                              {editState?.number}
                            </p>
                          </div>

                          <div className="col-md-4 text-start">
                            <button
                              type="button"
                              // disabled={button == false}
                              className="btn approved_Up w-auto m-0"
                              style={{ fontSize: "12px" }}
                              onClick={() => {
                                props.login(editState?.userName);
                              }}
                            >
                              Login As User
                              {/* <ArrowForwardIcon
                                        style={{ fontSize: "17px" }}
                                      /> */}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ul class="nav nav-tabs pt-2" id="myTab" role="tablist">
                  <li class="nav-item" role="presentation">
                          <button
                            class="nav-link active"
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#sms"
                            type="button"
                            role="tab"
                            aria-controls="AccountDetails"
                            aria-selected="true"
                          >
                            Profile
                          </button>
                        </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ms-2"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#AccountDetails"
                        type="button"
                        role="tab"
                        aria-controls="AccountDetails"
                        aria-selected="true"
                      >
                        SMS
                      </button>
                    </li>

                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ms-2"
                        id="pills-contact-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-contact"
                        type="button"
                        role="tab"
                        aria-controls="pills-contact"
                        aria-selected="false"
                      >
                        Recharge
                      </button>
                    </li>

                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link ms-2"
                        id="pills-contact-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-password"
                        type="button"
                        role="tab"
                        aria-controls="pills-contact"
                        aria-selected="false"
                      >
                        Change Password
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                        <div
                          class="tab-pane fade show active"
                          id="sms"
                          role="tabpanel"
                          aria-labelledby="sms-tab"
                        >
                          <div className="text-end fw-bold">
                            {/* Edit User
                            <ArrowForwardIcon
                              style={{
                                fontSize: "20px",
                              }}
                            />{" "} */}
                            &nbsp; &nbsp;
                            {button == false ? (
                              <EditIcon
                                style={{
                                  cursor: "pointer",
                                  marginBottom: "20px",
                                  fontSize: "20px",
                                }}
                                onClick={() => {
                                  setButton(true);
                                }}
                                className="text-end mt-3 edit_btn_up"
                              />
                            ) : (
                              <CancelIcon
                                style={{
                                  cursor: "pointer",
                                  fontSize: "20px",
                                  marginBottom: "20px",
                                }}
                                onClick={() => {
                                  setButton(false);
                                }}
                                className="text-end mt-3 cross_btn_up"
                              />
                            )}
                          </div>

                          <ThemeProvider theme={theme}>
                            <div class="card shadow-none border mt-3 bg_blue">
                              <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                                Details
                              </span>
                              <div
                                class="card-body text-lg-start text-center"
                                id="card_body_profile"
                              >
                                <form onSubmit={formik1.handleSubmit}>
                                  <div class="row mb-3 ">
                                    <div class="col-md-4">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <TextField
                                          disabled
                                          required
                                          className="w-100"
                                          label="Username"
                                          name="userName"
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          value={formik1.values.userName}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.userName &&
                                            Boolean(formik1.errors.userName)
                                          }
                                          helperText={
                                            formik1.touched.userName &&
                                            formik1.errors.userName
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div className="d-flex align-items-center justify-content-between ">
                                        <TextField
                                          disabled={button == false}
                                          required
                                          className="w-100"
                                          label="Email_id"
                                          name="email"
                                          variant="outlined"
                                          size="small"
                                          type="email"
                                          value={formik1.values.email}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.email &&
                                            Boolean(formik1.errors.email)
                                          }
                                          helperText={
                                            formik1.touched.email &&
                                            formik1.errors.email
                                          }
                                        />
                                      </div>
                                    </div>

                                    <div className="col-md-4" id="inp_merge">
                      <div className="d-flex h-100">
                      <input className="inpt_width h-100"
  disabled
  value="+222"
/>
                                        <TextField
                                          disabled={button == false}
                                          required
                                          className="w-100"
                                          label="Phone Number"
                                          name="number"
                                          variant="outlined"
                                          size="small"
                                          type="number"
                                          value={formik1?.values?.number?.slice(3)}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.number &&
                                            Boolean(formik1.errors.number)
                                          }
                                          helperText={
                                            formik1.touched.number &&
                                            formik1.errors.number
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-md-4 ">
                                      <div className="d-flex align-items-center justify-content-between ">
                                        <TextField
                                          disabled
                                          required
                                          className="w-100"
                                          label="Last Login Date"
                                          name="lastLogin"
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          value={formik1.values.lastLogin}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.lastLogin &&
                                            Boolean(formik1.errors.lastLogin)
                                          }
                                          helperText={
                                            formik1.touched.lastLogin &&
                                            formik1.errors.lastLogin
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div className="d-flex align-items-center justify-content-between ">
                                        <TextField
                                          disabled={button == false}
                                          required
                                          className="w-100"
                                          label="Last Login Ip"
                                          name="lastLoginIp"
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          value={formik1.values.lastLoginIp}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.lastLoginIp &&
                                            Boolean(formik1.errors.lastLoginIp)
                                          }
                                          helperText={
                                            formik1.touched.lastLoginIp &&
                                            formik1.errors.lastLoginIp
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div class="col-md-4">
                                      <div className="d-flex align-items-center justify-content-between ">
                                        <TextField
                                          // disabled={button == false}
                                          disabled
                                          required
                                          className="w-100"
                                          label="Account Type"
                                          name="account"
                                          variant="outlined"
                                          size="small"
                                          type="text"
                                          value={formik1.values.account}
                                          onChange={formik1.handleChange}
                                          error={
                                            formik1.touched.account &&
                                            Boolean(formik1.errors.account)
                                          }
                                          helperText={
                                            formik1.touched.account &&
                                            formik1.errors.account
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="text-end">
                                    <button
                                      type="submit"
                                      disabled={button == false}
                                      className="btn green_UP m-0"
                                    >
                                      Update
                                      {/* <ArrowForwardIcon
                                        style={{ fontSize: "17px" }}
                                      /> */}
                                    </button>

                                    <button
                                      style={{ marginLeft: "6px" }}
                                      type="button"
                                      disabled={button == false}
                                      onClick={modelBlockUser}
                                      className="btn failClr m-0 ms-2"
                                    >
                                      Block
                                      {/* <BlockIcon style={{ fontSize: "17px" }} /> */}
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </ThemeProvider>
                        </div>
                      </div>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade "
                      id="AccountDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <ul class="nav nav-tabs pt-4" id="myTab" role="tablist">
                        {/* <li class="nav-item" role="presentation">
                          <button
                            class="nav-link active"
                            id="home-tab"
                            data-bs-toggle="tab"
                            data-bs-target="#sms"
                            type="button"
                            role="tab"
                            aria-controls="AccountDetails"
                            aria-selected="true"
                          >
                            Profile
                          </button>
                        </li> */}
                        {JSON.parse(localStorage.getItem("Sidebaritems"))
                          ?.name == "ROLE_SUPER_ADMIN" ? (
                          <>
                            {/* <li class="nav-item" role="presentation">
                              <button
                                class="nav-link"
                                id="Route-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#Route"
                                type="button"
                                role="tab"
                                aria-controls="profile"
                                aria-selected="false"
                              >
                                Route Allocation
                              </button>
                            </li> */}
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link ms-2 active"
                                id="SenderID-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#SenderID"
                                type="button"
                                role="tab"
                                aria-controls="profile"
                                aria-selected="false"
                              >
                                SenderID
                              </button>
                            </li>
                            <li class="nav-item" role="presentation">
                              <button
                                class="nav-link ms-2"
                                id="TemplateID-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#TemplateID"
                                type="button"
                                role="tab"
                                aria-controls="profile"
                                aria-selected="false"
                              >
                                Template
                              </button>
                            </li>
                          </>
                        ) : null}
                      </ul>
                    

                      <div
                        class="tab-pane fade"
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div class="card shadow-none border mt-5 bg_blue">
                          <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                            Account Details
                          </span>
                          <div class="card-body text-lg-start text-center">
                            <div class="row mb-3">
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Smpp User?
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    IP Validation
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Web Push Delivery
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Secure Reporting
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Validate Spam
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Daily Email Notification
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    Open SenderId User
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div className="d-flex align-items-center justify-content-between">
                                  <label
                                    for="exampleInputEmail1"
                                    class="form-label m-0 labelfont"
                                  >
                                    API Rights
                                  </label>
                                  <span class="badge bg-success">
                                    Enabled <ThumbUpAltIcon />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                      "ROLE_SUPER_ADMIN" ? (
                        <>
                          <div
                            class="tab-pane fade "
                            id="Route"
                            role="tabpanel"
                            aria-labelledby="Route-tab"
                          >
                            {/* <div class="card-body"> */}
                            <div class="card shadow-none border mb-5 mt-4 bg_blue">
                              <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                                Routes
                              </span>
                              <ViewRouteAlloted />
                              {/* <div class="card-body text-lg-start text-center">
                            <div className="d-flex justify-content-between my-3">
                              <select
                                value={pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      {" "}
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>

                              <div></div>
                              <TextField
                                className="ms-4 "
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Search"
                                name="Search"
                                variant="outlined"
                             
                                size="small"
                                value={globalSearchValue || ""}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  setGlobalSearchValue(e.target.value);
                                }}
                              />
                            </div>

                            <div className="text-end">
                              {selectedFlatRows.length > 0 && (
                                <button
                        
                                  className="btn bg-gradient-primary m-0"
                                >
                                  Delete Users
                                </button>
                              )}

                              
                            </div>
                            <div className="table-responsive">
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                              
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-left width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className="text-left"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                <span>
                                  Page:
                                  <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                  </strong>
                                </span>

                                <span>
                                  | Go to Page :{""}
                                  <input
                                    type="number"
                                  
                                    value={pageIndex}
                                    onChange={(e) => {
                                      const pageNumber = e.target.value
                                        ? Number(e.target.value) - 1
                                        : 0;
                                      gotoPage(pageNumber);
                                    }}
                                    style={{ width: "50px" }}
                                  />
                                </span>
                              </div>

                              <div id="nikhil">
                                <button
                                  className="btn btn_primary m-0"
                                  type="button"
                                  disabled={!canPreviousPage}
                                  onClick={() => {
                                    previousPage();
                                  }}
                                >
                                  Prev
                                </button>

                                <button
                                  className="btn btn_primary m-0 ms-2"
                                  type="button"
                                  disabled={!canNextPage}
                                  onClick={() => {
                                    nextPage();
                                  }}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div> */}
                            </div>
                          </div>
                          <div
                            class="tab-pane fade show active"
                            id="SenderID"
                            role="tabpanel"
                            aria-labelledby="Route-tab"
                          >
                            {" "}
                            <div class="card shadow-none border mt-5 bg_blue">
                              <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                                Sender ID
                              </span>
                              <ViewUserSenderId id={editState?.uid}/>
                              {/* <ViewSenderId /> */}
                              {/* <ViewPendingSenderId/> */}
                              {/* <div class="card-body text-lg-start text-center">
                            <div className="d-flex justify-content-between my-3">
                              <select
                                value={pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      {" "}
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>

                              <div></div>
                              <TextField
                                className="ms-4 "
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Search"
                                name="Search"
                                variant="outlined"
                          
                                size="small"
                                value={globalSearchValue || ""}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  setGlobalSearchValue(e.target.value);
                                }}
                              />
                            </div>

                            <div className="text-end">
                              {selectedFlatRows.length > 0 && (
                                <button className="btn bg-gradient-primary m-0">
                                  Delete Users
                                </button>
                              )}
                            </div>
                            <div className="table-responsive">
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-left width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className="text-left"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                <span>
                                  Page:
                                  <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                  </strong>
                                </span>

                                <span>
                                  | Go to Page :{""}
                                  <input
                                    type="number"
                                    defaultValue={pageIndex + 1}
                                    onChange={(e) => {
                                      const pageNumber = e.target.value
                                        ? Number(e.target.value) - 1
                                        : 0;
                                      gotoPage(pageNumber);
                                    }}
                                    style={{ width: "50px" }}
                                  />
                                </span>
                              </div>

                              <div id="nikhil">
                                <button
                                  className="btn btn_primary m-0"
                                  type="button"
                                  disabled={!canPreviousPage}
                                  onClick={() => {
                                    previousPage();
                                  }}
                                >
                                  Prev
                                </button>

                                <button
                                  className="btn btn_primary m-0 ms-2"
                                  type="button"
                                  disabled={!canNextPage}
                                  onClick={() => {
                                    nextPage();
                                  }}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div> */}
                            </div>
                          </div>
                          <div
                            class="tab-pane fade"
                            id="TemplateID"
                            role="tabpanel"
                            aria-labelledby="TemplateID-tab"
                          >
                            {" "}
                            <div class="card shadow-none border mt-5 bg_blue">
                              <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                                Template-ID
                              </span>

                              {/* <div class="card-body text-lg-start text-center">
                            <div className="d-flex justify-content-between my-3">
                              <select
                                value={pageSize}
                                className="dropdown"
                                onChange={(e) => {
                                  setPageSize(Number(e.target.value));
                                }}
                              >
                                {[10, 25, 50].map((value, i) => {
                                  return (
                                    <option
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton1"
                                      value={value}
                                      key={value}
                                    >
                                      {" "}
                                      Show {value}
                                    </option>
                                  );
                                })}
                              </select>

                              <div></div>
                              <TextField
                                className="ms-4 "
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Search"
                                name="Search"
                                variant="outlined"
                        
                                size="small"
                                value={globalSearchValue || ""}
                                onChange={(e) => {
                                  onChange(e.target.value);
                                  setGlobalSearchValue(e.target.value);
                                }}
                              />
                            </div>

                            <div className="text-end">
                              {selectedFlatRows.length > 0 && (
                                <button className="btn bg-gradient-primary m-0">
                                  Delete Users
                                </button>
                              )}
                            </div>
                            <div className="table-responsive">
                              <table
                                {...getTableProps()}
                                id="example"
                                className="table table-striped table-bordered dataTable table-sm mt-3 table-responsive"
                              >
                                <thead>
                                  {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                          )}
                                          className="text-left width_2"
                                        >
                                          {column.render("Header")}
                                          <span>
                                            {column.isSorted
                                              ? column.isSortedDesc
                                                ? "↑"
                                                : "↓"
                                              : ""}
                                          </span>
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>
                                <tbody {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => {
                                          return (
                                            <td
                                              {...cell.getCellProps()}
                                              className="text-left"
                                            >
                                              {cell.render("Cell")}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                <span>
                                  Page:
                                  <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                  </strong>
                                </span>

                                <span>
                                  | Go to Page :{""}
                                  <input
                                    type="number"
                                   
                                    value={pageIndex}
                                    onChange={(e) => {
                                      const pageNumber = e.target.value
                                        ? Number(e.target.value) - 1
                                        : 0;
                                      gotoPage(pageNumber);
                                    }}
                                    style={{ width: "50px" }}
                                  />
                                </span>
                              </div>

                              <div id="nikhil">
                                <button
                                  className="btn btn_primary m-0"
                                  type="button"
                                  disabled={!canPreviousPage}
                                  onClick={() => {
                                    previousPage();
                                  }}
                                >
                                  Prev
                                </button>

                                <button
                                  className="btn btn_primary m-0 ms-2"
                                  type="button"
                                  disabled={!canNextPage}
                                  onClick={() => {
                                    nextPage();
                                  }}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          </div> */}
                              {/* <ViewTemplatesAdmin /> */}
<ViewUserTemplate id= {editState?.uid}/>
                            </div>
                          </div>
                        </>
                      ) : null}
                      {/* <div
                        class="tab-pane fade "
                        id="SenderMasking"
                        role="tabpanel"
                        aria-labelledby="SenderMasking-tab"
                      >
                        <div class="card shadow-none border mt-5 bg_blue">
                          <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                            Voice Details
                          </span>
                          <div class="card-body text-lg-start text-center">
                            <div class="row">
                              <div class="col-md-3">
                                <div class="input-group input-group-outline mb-3">
                                  <label class="form-label">
                                    Name
                                    <span class="text-danger fw-bold">*</span>
                                  </label>
                                  <input type="text" class="form-control" />
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="input-group input-group-outline mb-3">
                                  <label class="form-label">
                                    Mobile no
                                    <span class="text-danger fw-bold">*</span>
                                  </label>
                                  <input type="password" class="form-control" />
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="input-group input-group-outline mb-3">
                                  <label class="form-label">
                                    Email id
                                    <span class="text-danger fw-bold">*</span>
                                  </label>
                                  <input type="text" class="form-control" />
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="input-group input-group-outline mb-3">
                                  <label class="form-label">
                                    Role
                                    <span class="text-danger fw-bold">*</span>
                                  </label>
                                  <input type="text" class="form-control" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}

                      <div
                        class="tab-pane fade "
                        id="Recharge"
                        role="tabpanel"
                        aria-labelledby="Recharge-tab"
                      >
                      </div>
                      
                    </div>

                    <div
                      class="tab-pane fade"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      ...888
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-contact"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                     <Rechargemanagement
                     />
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-child"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                      child
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-password"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                      <div class="card shadow-none border mb-5 mt-5  bg_blue">
                        <span class="badge rounded-pill bg-primary mt-n3 ms-5">
                          Change Password
                        </span>
                        <div className="card-body text-lg-start text-center">
                          <ThemeProvider theme={theme}>
                            <form onSubmit={formik.handleSubmit}>
                              <div className="row">
                                <div className="col-md-4">
                                  <TextField
                                    required
                                    className="w-100"
                                    label="New Password"
                                    name="newPassword"
                                    type={showPassword1 ? "text" : "password"}
                                    variant="outlined"
                                    size="small"
                                    value={formik.values.newPassword}
                                    onChange={formik.handleChange}
                                    error={
                                      formik.touched.newPassword &&
                                      Boolean(formik.errors.newPassword)
                                    }
                                    helperText={
                                      formik.touched.newPassword &&
                                      formik.errors.newPassword
                                    }
                                    InputProps={{
                                      // <-- This is where the toggle button is added.
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword1}
                                            onMouseDown={
                                              handleMouseDownPassword1
                                            }
                                          >
                                            {showPassword1 ? (
                                              <VisibilityIcon
                                                sx={{ color: "#85CBF2" }}
                                              />
                                            ) : (
                                              <VisibilityOffIcon
                                                sx={{ color: "#85CBF2" }}
                                              />
                                            )}
                                          </IconButton>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </div>

                                <div className="col-md-4">
                                  <div className="input-group input-group-outline mb-3">
                                    <TextField
                                      required
                                      className="w-100"
                                      label="Confirm Password"
                                      name="confirmPassword"
                                      type={showPassword2 ? "text" : "password"}
                                      variant="outlined"
                                      size="small"
                                      value={formik.values.confirmPassword}
                                      onChange={formik.handleChange}
                                      error={
                                        formik.touched.confirmPassword &&
                                        Boolean(formik.errors.confirmPassword)
                                      }
                                      helperText={
                                        formik.touched.confirmPassword &&
                                        formik.errors.confirmPassword
                                      }
                                      InputProps={{
                                        // <-- This is where the toggle button is added.
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton
                                              aria-label="toggle password visibility"
                                              onClick={handleClickShowPassword2}
                                              onMouseDown={
                                                handleMouseDownPassword2
                                              }
                                            >
                                              {showPassword2 ? (
                                                <VisibilityIcon
                                                  sx={{ color: "#85CBF2" }}
                                                />
                                              ) : (
                                                <VisibilityOffIcon
                                                  sx={{ color: "#85CBF2" }}
                                                />
                                              )}
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between">

                              <button
                                  style={{ marginLeft: "6px" }}
                                  type="button"
                                  onClick={formik.resetForm}
                                  className="btn resetBtn_UP m-0 ms-2"
                                >
                                  Reset
                                  {/* <i className="material-icons opacity-10">
                                    settings_backup_restore
                                  </i> */}
                                </button>

                                <button
                                  type="submit"
                                  className="btn bg-gradient-primary m-0"
                                >
                                  Submit
                                  {/* <i className="material-icons opacity-10">
                                    arrow_right_alt
                                  </i> */}
                                </button>

                                
                              </div>
                            </form>
                          </ThemeProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoginLoader visible={props.loading} />
      </main>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  login: (username) => dispatch(loginAsUser(username)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);

